export default __webpack_public_path__ + "static/media/e614ca2076f8120ace2560840a2db3f51581007445687.89dec596.webp";